import { Api as Customer } from './customer';
import { Api as Settlement } from './settlement';
import { Api as Smc } from './smc';

import { serviceConfig } from '@/config/request/swaggerServiceConfig';

export const Api = { Customer, Settlement, Smc };

const warpperServiceConfig = (serviceConfig: any, ctx: { name: string; basePath: string; }) => {
        const newConfig = { ...serviceConfig };
        if (newConfig.baseURL) {
            newConfig.baseURL = newConfig.baseURL + ctx.basePath;
        }
        return newConfig;
    };

const customer = new Customer(warpperServiceConfig(serviceConfig, { name: 'customer', basePath: '/customer' }));
const settlement = new Settlement(warpperServiceConfig(serviceConfig, { name: 'settlement', basePath: '/settlement' }));
const smc = new Smc(warpperServiceConfig(serviceConfig, { name: 'smc', basePath: '/smc' }));

export const apiInstanceList = [{ key: 'customer', instance: customer }, { key: 'settlement', instance: settlement }, { key: 'smc', instance: smc }];

export const api = { customer, settlement, smc };